import { jsx as _jsx } from "react/jsx-runtime";
import { StackView, Box } from '@telus-uds/components-web';
import { PageNotification } from '../PageNotification/PageNotification';
import { useNotification } from './NotificationContext';
export var GlobalPageNotifications = function (_a) {
    var _b = _a.notifications, notifications = _b === void 0 ? [] : _b;
    var dynamicNotifications = useNotification().dynamicNotifications;
    var globalNotifications = notifications.concat(dynamicNotifications);
    return (_jsx(Box, { vertical: 1, children: _jsx(StackView, { space: 1, children: globalNotifications.map(function (notification, index) {
                var _a, _b;
                var key = (_b = (_a = notification.sys) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : index;
                return _jsx(PageNotification, { notification: notification, system: true }, key);
            }) }) }));
};
